export * from './ProjectDetails'

export type { ProjectDetailsProps } from './ProjectDetails.types'
